import { gql, useLazyQuery } from '@apollo/client';

export const SPOTS_PAGED_WITH_BOX_QUERY = gql`
    query getSpotsPagedWithBox(
        $bounds: BoundsInputObject
        $center: CoordinatesInputObject
        $filtersNew: FiltersInputObject
        $page: Int
        $limit: Int
        $sortBy: SortBy
        $sortOrder: SortOrder
        $hasPhotos: Boolean
        $testCase: String
    ) {
        spotsPagedWithBox(
            bounds: $bounds
            center: $center
            filtersNew: $filtersNew
            page: $page
            limit: $limit
            sortBy: $sortBy
            sortOrder: $sortOrder
            hasPhotos: $hasPhotos
            testCase: $testCase
        ) {
            spots {
                metadata {
                    totalPages
                    totalCount
                    currentPage
                    limitValue
                }
                collection {
                    id
                    title
                    rating
                    ratingV2
                    effectiveRatingV2
                    latitude
                    longitude
                    distanceFrom
                    allAmenities(limit: 21) {
                        component
                        name
                    }
                    topReview {
                        id
                        comment
                    }
                    live
                    spotPhotos {
                        id
                        imageAws
                    }
                    size
                    sizeUnits
                    filtered
                    price
                    offerSniffpass
                    reviewsCount
                    enclosureType
                    fenceHeight
                    privateEntry
                    dogsPresent
                    domesticAnimalsPresent
                    description
                    peoplePresent
                    top
                    new
                    risingStar
                    spotUrl
                    country
                    state
                    city
                    host {
                        id
                        nameAndInitial
                    }
                    publicPark
                    workHours
                    fee
                }
            }
            box {
                sw {
                    ...latlng
                }
                ne {
                    ...latlng
                }
                center {
                    ...latlng
                }
            }
        }
    }
    fragment latlng on CoordinatesObject {
        lat
        lng
    }
`;

export default function useGetSpotPagedBox() {
    const [getSpotPagedBox, { data, loading }] = useLazyQuery(SPOTS_PAGED_WITH_BOX_QUERY);
    return { getSpotPagedBox, spot: data && data.spot, loading };
}
